import axios from 'axios';

import GOOGLE_API_KEY from '../utils/googleAPIKey';

const URL = 'https://maps.googleapis.com/maps/api/geocode/json?language=el';

export async function geoCodePostal(postal) {
  try {
    const response = await axios.get(URL, {
      params: {
        region: 'GR',
        address: postal,
        key: GOOGLE_API_KEY,
      },
    });

    const addressObject = response?.data?.results?.[0] || {};
    const { lat = 0, lng = 0 } = addressObject.geometry?.location || {};
    const { long_name: city = '' } =
      addressObject.address_components?.find(addressInfo => addressInfo.types.includes('locality')) || {};

    return {
      data: {
        city,
        lat,
        lng,
      },
    };
  } catch (error) {
    return {
      data: {
        city: '',
        lat: 0,
        lng: 0,
      },
      error,
    };
  }
}
